import { index, integer, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getId,
  getIdReference,
  getTimestampWithTimezone,
  typedJsonb,
} from '../common/utils'
import { users } from './user'

// Operation type enum
export const auditOperationEnum = pgEnum('audit_operation', [
  'create',
  'update',
  'delete',
])

// Audit logs table
export const auditLogs = pgTable(
  'audit_logs',
  {
    id: getId(),
    createdAt: getTimestampWithTimezone().notNull().defaultNow(),
    entityType: text('entity_type').notNull(),
    entityId: integer('entity_id').notNull(),
    userId: getIdReference(() => users.id),
    operation: auditOperationEnum('operation').notNull(),
    changes: typedJsonb<unknown[]>('changes').notNull(),
  },
  (table) => [
    index(`audit_logs_created_at`).on(table.createdAt),
    index('audit_logs_entity_type').on(table.entityType),
    index('audit_logs_entity_id').on(table.entityId),
    index('audit_logs_user_id').on(table.userId),
  ],
)
